import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';

import { TIconName, Input } from '@treezor/design-system';

import { TCommonFilters, IAmountRangeFilter } from '@/features/wallets/types/index';

import { IFilterFields } from './filters.type';
import { CustomPopover, ICustomPopoverProps } from './CustomPopover';

interface IAmountFilterProps {
  onFilterChange: (filters: TCommonFilters) => void;
}

export const AmountFilter = ({ onFilterChange }: IAmountFilterProps) => {
  const { t } = useTranslation();
  const { watch, getValues, register } = useFormContext<IAmountRangeFilter>();
  const amountRange = watch('amountRange');

  const amountFields: IFilterFields<IAmountRangeFilter>[] = [
    {
      title: t('components.filters.amount.from'),
      name: 'amountRange.minimum',
      label: t('components.filters.amount.labels.mini'),
    },
    {
      title: t('components.filters.amount.to'),
      name: 'amountRange.maximum',
      label: t('components.filters.amount.labels.maxi'),
    },
  ];

  const handleAmountRangeTransactions = () => {
    const transactionsFilters = getValues();

    onFilterChange({ ...transactionsFilters, ...getValues('amountRange') });
  };

  const filterAmount: ICustomPopoverProps = {
    id: 'amount-range',
    label: t('components.filters.amount.title'),
    icon: 'euro',
    content: (
      <div className="p-5 flex flex-col items-center justify-start gap-3">
        {amountFields.map(({ title, label, name }) => (
          <Input
            type="number"
            size="s"
            key={name}
            title={title}
            label={label}
            {...register(name)}
            onBlur={handleAmountRangeTransactions}
            data-test-id={name.replace('.', '-')}
          />
        ))}
      </div>
    ),
    indication: [amountRange?.maximum, amountRange?.minimum].filter((amount) => amount).length,
  };

  return (
    <CustomPopover
      label={filterAmount.label}
      icon={filterAmount.icon as TIconName}
      content={filterAmount.content}
      indication={filterAmount.indication}
      id={filterAmount.id}
    />
  );
};
